import { render } from "./AdminDonaties.vue?vue&type=template&id=27c37082"
import script from "./AdminDonaties.vue?vue&type=script&lang=js"
export * from "./AdminDonaties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__